import axios from 'axios';
import { useCallback, useMemo, useState } from 'react';
import Form, { Validations } from '../../../../../components/Form';
import { ControlItem } from '../../../types';

import ServicePaths from '../../../../../bridge/utils/ServicePaths';

const RemoveUserForm = () => {
  const [userId, setUserId] = useState<string | undefined>();
  const [errors, setErrors] = useState<Record<string, Validations>>({});
  const [formMessage, setFormMessage] = useState();
  const [isLoading, setIsLoading] = useState(false);

  const checkUserIdValidation = useCallback(() => {
    /** userId can not be empty */

    setErrors({});

    if (typeof userId === 'undefined') {
      setErrors((prev) => ({
        ...prev,
        userId: Validations.Required,
      }));
    }

    return true;
  }, [userId]);

  const handleSubmit = useCallback(async () => {
    setIsLoading(true);
    const canContinue = checkUserIdValidation();

    if (!canContinue) {
      setIsLoading(false);
      return;
    }

    const { data } = await axios({
      method: 'POST',
      url: ServicePaths.CONTROL.RemoveUser,
      params: {
        userId,
      },
    });

    setIsLoading(false);
    setFormMessage(data);
  }, [checkUserIdValidation, userId]);

  const config = useMemo(() => {
    return {
      title: ControlItem.RemoveUser,
      formMessage,
      fields: [
        {
          label: 'User Id',
          value: userId,
          handleValueChange: setUserId,
          error: errors.userId,
        },
      ],
      handleSubmit: handleSubmit,
      isLoading,
    };
  }, [errors.userId, formMessage, handleSubmit, isLoading, userId]);

  return <Form config={config} />;
};

export default RemoveUserForm;
